import { cn } from '@/lib/utils';

interface WordmarkProps {
  size?: 'sm' | 'base' | 'lg' | 'xl' | '2xl';
  weight?: 'medium' | 'semibold' | 'bold';
  className?: string;
}

const SIZE_CLASS: Record<NonNullable<WordmarkProps['size']>, string> = {
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
};

const WEIGHT_CLASS: Record<NonNullable<WordmarkProps['weight']>, string> = {
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
};

/**
 * Canonical brand wordmark: "252signal" — fully foreground (no color split).
 * Phase 10 light brokerage theme: cyan retired site-wide.
 */
const Wordmark = ({ size = 'base', weight = 'bold', className }: WordmarkProps) => (
  <span
    className={cn(
      'tracking-tight text-foreground',
      SIZE_CLASS[size],
      WEIGHT_CLASS[weight],
      className,
    )}
  >
    <span className="text-brand-mark">252</span>
    <span>signal</span>
  </span>
);

export default Wordmark;
